import { prefetchModelIndex } from '@rhino-project/core/hooks';
import { createFileRoute } from '@tanstack/react-router';
import DatabasePage from '../../../../pages/database/DatabasePage';

export const Route = createFileRoute('/_authenticated/$owner/database/')({
  loader: ({ context: { rhino } }) => {
    return prefetchModelIndex(rhino, 'external_player');
  },
  component: DatabasePage
});
